/**
 * Opt-in console diagnostics for the custom layer click/event chain.
 * Enable from the browser console (takes effect immediately, no reload):
 *
 *   localStorage.setItem('jwxDebugCustomLayers', '1')
 *
 * Disable with localStorage.removeItem('jwxDebugCustomLayers').
 */
export function debugCustomLayers(...args) {
  try {
    if (window.localStorage.getItem('jwxDebugCustomLayers') !== '1') return;
  } catch {
    return;
  }

  console.log('[custom-layers]', ...args);
}
